import { sql } from '@w/db'
import type { WorkspaceDb } from './workspace-tables'

/** `usablePage` for a page already read: its title is text and it is no personal routing root (kind `personalRoot`). */
export function isUsablePage(page: { kind: string; title: unknown }) {
  return typeof page.title === 'string' && page.kind !== 'personalRoot'
}

// Personal routing roots are security nodes. Shared roots are ordinary pages,
// including roots with empty titles (page-permissions.spec.md:29).
export function usablePage(pages: WorkspaceDb['pages']) {
  return sql`typeof(${pages.title}) = 'text' AND ${pages.kind} != 'personalRoot'`
}
